import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";

/**
 * Section used to display the business overview for a period report.
 */
export default class BusinessOverviewSection extends AbstractPeriodReportSection {
	getTitle() {
		return _("Business");
	}

	getIcon() {
		return "business";
	}

	accept(visitor) {
		return visitor.visitBusinessOverviewSection(this);
	}

	static getType() {
		return "BusinessOverviewSection";
	}

	static getId() {
		return "business-overview";
	}
}
